import * as ActionTypes from "../actions/ActionTypes";

const initialState = {
	activities: [{}],
	favourites: [{}],
	photos:[],
	tourismEvents: [],
	informativeTexts: [],
	sideMenuOpen: false,
	formMenuOpen: false,
	textMenuOpen: false,
	modifyFormMenuOpen: false,
	calendarMenuOpen: true,
	informationsMenuOpen: false,
	inversionesMenuOpen: false,
	restaurantsMenuOpen: false,
	otherTextsMenuOpen: false,
	favouritesMenuOpen: false,
	promotionsMenuOpen: false,
	principalMenuOpen: false,
	listMenuOpen: false,
	photosMenuOpen: false,
	updateListMenu: false,
	uploadingImage: false,
	imageUrlResponse: "",
	deletingElement: false,
	creatingEvent: false,
	modifyingElement: false,
	modifyingInformativeText: false,
	eventToModify: {
		id: 0,
		type: "",
		titulo: "",
		info: "",
		link: "",
		imageUrl: ""
	},
	event: {
		imageUrl: ""
	},
	textToModify: {
		id: 0,
		type: "",
		title: "",
		info: ""
	}
};

const reducer = (state = initialState, action) => {
	switch (action.type) {
		case ActionTypes.LOAD_FAVOURITES:
			return {
				...state,
				favourites: action.favourites
			};
		case ActionTypes.LOAD_ACTIVITIES:
			return {
				...state,
				activities: action.activities
			};
		case ActionTypes.LOAD_INFORMATIONS:
			return {
				...state,
				informations: action.informations
			};
		case ActionTypes.LOAD_RESTAURANTS:
			return {
				...state,
				restaurants: action.restaurants
			};
		case ActionTypes.LOAD_OTHERTEXTS:
			return {
				...state,
				otherTexts: action.otherTexts
			};
		case ActionTypes.LOAD_INVERSIONES:
			return {
				...state,
				inversiones: action.inversiones
			};
		case ActionTypes.LOAD_PROMOTIONS:
			return {
				...state,
				promotions: action.promotions
			};
		case ActionTypes.LOAD_PRINCIPAL:
			return {
				...state,
				principal: action.principal
			};

		case ActionTypes.LOAD_PHOTOS:
			return {
				...state,
				photos: action.photos
			};


		case ActionTypes.LOAD_USERS:
			return {
				...state,
				users: action.users
			};

		case ActionTypes.OPENCLOSE_SIDEMENU:
			return {
				...state,
				sideMenuOpen: !state.sideMenuOpen
			};
		case ActionTypes.OPEN_FORMMENU:
			return {
				...state,
				sideMenuOpen: false,
				listMenuOpen: false,
				textMenuOpen: false,
				formMenuOpen: true,
				principalMenuOpen: false,
				favouritesMenuOpen: false
			};
		case ActionTypes.OPEN_ACTIVITIES:
			return {
				...state,
				sideMenuOpen: false,
				calendarMenuOpen: true,
				usuariosMenuOpen: false,
				informationsMenuOpen: false,
				favouritesMenuOpen: false,
				principalMenuOpen: false,
				promotionsMenuOpen: false,
				photosMenuOpen: false,
			};

		case ActionTypes.OPEN_USUARIOS:
			return {
				...state,
				sideMenuOpen: false,
				calendarMenuOpen: false,
				usuariosMenuOpen: true,
				informationsMenuOpen: false,
				favouritesMenuOpen: false,
				principalMenuOpen: false,
				promotionsMenuOpen: false,
				photosMenuOpen: false,
				inversionesMenuOpen: false,
				otherTextsMenuOpen: false,
				restaurantsMenuOpen: false,
			};
		case ActionTypes.OPEN_FAVOURITES:
			return {
				...state,
				sideMenuOpen: false,
				calendarMenuOpen: false,
				usuariosMenuOpen: false,
				informationsMenuOpen: false,
				favouritesMenuOpen: true,
				promotionsMenuOpen: false,
				principalMenuOpen: false,
				photosMenuOpen: false,
				inversionesMenuOpen: false,
				otherTextsMenuOpen: false,
				restaurantsMenuOpen: false,
			};
		case ActionTypes.OPEN_PROMOTIONS:
			return {
				...state,
				sideMenuOpen: false,
				calendarMenuOpen: false,
				usuariosMenuOpen: false,
				informationsMenuOpen: false,
				favouritesMenuOpen: false,
				principalMenuOpen: false,
				promotionsMenuOpen: true,
				photosMenuOpen: false,
				inversionesMenuOpen: false,
				otherTextsMenuOpen: false,
				restaurantsMenuOpen: false,
			};
		case ActionTypes.OPEN_PRINCIPAL:
			return {
				...state,
				sideMenuOpen: false,
				calendarMenuOpen: false,
				usuariosMenuOpen: false,
				informationsMenuOpen: false,
				favouritesMenuOpen: false,
				promotionsMenuOpen: false,
				principalMenuOpen: true,
				photosMenuOpen: false,
				inversionesMenuOpen: false,
				otherTextsMenuOpen: false,
				restaurantsMenuOpen: false,
			};

		case ActionTypes.OPEN_INFORMATIONS:
			return {
				...state,
				sideMenuOpen: false,
				calendarMenuOpen: false,
				usuariosMenuOpen: false,
				informationsMenuOpen: true,
				favouritesMenuOpen: false,
				principalMenuOpen: false,
				promotionsMenuOpen: false,
				photosMenuOpen: false,
				inversionesMenuOpen: false,
				otherTextsMenuOpen: false,
				restaurantsMenuOpen: false,
			};

			case ActionTypes.OPEN_INVERSIONES:
				return {
					...state,
					sideMenuOpen: false,
					calendarMenuOpen: false,
					usuariosMenuOpen: false,
					inversionesMenuOpen: true,
					informationsMenuOpen: false,
					favouritesMenuOpen: false,
					principalMenuOpen: false,
					promotionsMenuOpen: false,
					photosMenuOpen: false,
					otherTextsMenuOpen: false,
					restaurantsMenuOpen: false,
				};

			case ActionTypes.OPEN_RESTAURANTS:
				return {
					...state,
					sideMenuOpen: false,
					calendarMenuOpen: false,
					usuariosMenuOpen: false,
					inversionesMenuOpen: false,
					informationsMenuOpen: false,
					favouritesMenuOpen: false,
					principalMenuOpen: false,
					promotionsMenuOpen: false,
					photosMenuOpen: false,
					otherTextsMenuOpen: false,
					restaurantsMenuOpen: true,
				};

			case ActionTypes.OPEN_OTHERTEXTS:
				return {
					...state,
					sideMenuOpen: false,
					calendarMenuOpen: false,
					usuariosMenuOpen: false,
					inversionesMenuOpen: false,
					informationsMenuOpen: false,
					favouritesMenuOpen: false,
					principalMenuOpen: false,
					promotionsMenuOpen: false,
					photosMenuOpen: false,
					otherTextsMenuOpen: true,
					restaurantsMenuOpen: false,
				};

			case ActionTypes.OPEN_PHOTOS:
				return {
					...state,
					sideMenuOpen: false,
					calendarMenuOpen: false,
					usuariosMenuOpen: false,
					informationsMenuOpen: false,
					favouritesMenuOpen: false,
					principalMenuOpen: false,
					promotionsMenuOpen: false,
					photosMenuOpen: true,
					inversionesMenuOpen: false,
					otherTextsMenuOpen: false,
					restaurantsMenuOpen: false,
				};

		case ActionTypes.UPLOADING_IMAGE:
			return {
				...state,
				uploadingImage: true,
				event: {
					...state.event,
					imageUrl: action.imageUrl
				}
			};
		default:
			return state;
	}
};

export default reducer;
